<div class="lidl-lib-cart-fe-add-to-cart input-group">
    <div class="lidl-lib-cart-fe-add-to-cart__actions" [ngClass]="{'variable-price': !isFixed}">
        <div>
            <div class="lidl-lib-cart-fe-add-to-cart__actions__inputs">
                <label>{{ "modeso_cart_add-to-cart-amount_caption" | injectedText | async }}</label>
                <input maxlength="3" [ngModel]="amount" (ngModelChange)="amount = $event; changeAmount()"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
               
            </div>
            <div class="lidl-lib-cart-fe-add-to-cart__actions__inputs" *ngIf="!isFixed">
                <label>{{ "modeso_cart_add-to-cart-price_caption" | injectedText | async }}</label>
                <input maxlength="4" id="variable-price" [ngModel]="price" (ngModelChange)="price = $event; changeVariablePrice()"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
            </div>
        </div>
        <button class="btn-cta" (click)="addToCart()" id="addToCartBtn">{{caption}} </button>
    </div>
    <div class="lidl-lib-cart-fe-add-to-cart__fixed-price" *ngIf="isFixed">
        <p><small>CHF</small> {{price}}</p>
    </div>
</div>